import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import LMForm from '../../components/LearningModule/LMForm';
import BreadCrumb from '../../components/Breadcrumb';
import * as actions from '../../redux/actions/actions-learningmodule';

class addLM extends Component {
  constructor(props) {
    super(props);

    if (props.match.params.id !== '0') {
      props.setForm(props.match.params.id);
    } else {
      props.resetForm();
    }
    this.state = {
      courseId: props.location.state.courseId
    };
  }


  handleSubmit = (FormData) => {
    // console.log('formData', { ...FormData, CourseId: this.state.courseId });
    this.props.saveLM({ ...FormData, CourseId: this.state.courseId });
  }


  render() {
    return (
      <>
        <div className="container">
          <BreadCrumb currentPage="Page" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    { this.props.match.params.id !== '0'
                      ? <span className="fa fa-pencil-alt cardTitle"> Edit Learning Module</span>
                      : <span className="fa fa-plus-square cardTitle"> Create New Learning Module</span>}
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fa fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                {/* <h3>fnkbfgjbfgb</h3> */}
                <LMForm
                  onSubmit={this.handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

addLM.propTypes = {
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  saveLM: PropTypes.func
};

addLM.defaultProps = {
  formLoading: null,
  formError: null,
  saveLM: null
};

const mapStateToProps = ({ learningModule }) => ({});


const mapDispatchToProps = (dispatch) => ({
  saveLM: (data) => dispatch(actions.saveLM(data)),
  setForm: (id) => dispatch(actions.editLM(id)),
  resetForm: () => dispatch(actions.resetForm())
});

export default connect(mapStateToProps, mapDispatchToProps)(addLM);
